export interface HistoricalCase {
  districtId: string;
  week: number;
  year: number;
  date: string;
  cases: number;
  rainfall: number;
  temperature: number;
  seasonalityIndex: number;
}

// Generate 2 years (104 weeks) of synthetic weekly data with seasonal malaria patterns
// Peak season: weeks 25-40 (May-Oct, rainy season)
function generateHistoricalCases() {
  const data: HistoricalCase[] = [];
  const weekOfYear = (date: Date) => {
    const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    const dayNum = d.getUTCDay() || 7;
    d.setUTCDate(d.getUTCDate() + 4 - dayNum);
    const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    return Math.ceil(((d.getTime() - yearStart.getTime()) / 86400000 + 1) / 7);
  };

  const districtBaseRates: Record<string, number> = {
    D01: 85, D02: 92, D03: 78, D04: 120, D05: 65,
    D06: 110, D07: 88, D08: 70, D09: 55, D10: 72,
    D11: 125, D12: 60, D13: 95, D14: 90, D15: 50,
    D16: 45, D17: 58, D18: 40, D19: 105, D20: 68,
  };

  const baseDate = new Date("2024-01-01");

  for (let week = 0; week < 104; week++) {
    const currentDate = new Date(baseDate);
    currentDate.setDate(baseDate.getDate() + week * 7);
    const weekNum = weekOfYear(currentDate);
    const year = currentDate.getFullYear();

    // Seasonal multiplier: peak in rainy season (weeks 25-40)
    const seasonMultiplier = weekNum >= 25 && weekNum <= 40 ? 1.8 : 0.6;
    // Random weekly fluctuation
    const noise = () => 0.7 + Math.random() * 0.6;

    for (const districtId of Object.keys(districtBaseRates)) {
      const base = districtBaseRates[districtId];
      const cases = Math.round(base * seasonMultiplier * noise());
      const rainfall = weekNum >= 25 && weekNum <= 40 ? 120 + Math.random() * 180 : 15 + Math.random() * 50;
      const temperature = 22 + Math.random() * 8; // 22-30°C
      const seasonalityIndex = seasonMultiplier;

      data.push({
        districtId,
        week: weekNum,
        year,
        date: currentDate.toISOString().split("T")[0],
        cases: Math.max(0, cases),
        rainfall: Math.round(rainfall * 10) / 10,
        temperature: Math.round(temperature * 10) / 10,
        seasonalityIndex: Math.round(seasonalityIndex * 100) / 100,
      });
    }
  }

  return data;
}

export const historicalCases = generateHistoricalCases();